export default __webpack_public_path__ + "static/media/home-slider-4-comp.f599b70f.png";